/**
 * Reducer: Availability
 */

import {
  FETCH_AVAILABILITY_REQUEST,
  FETCH_AVAILABILITY_SUCCESS,
  FETCH_AVAILABILITY_FAILURE
} from '../../actionTypes/availabilityActionTypes'

import { buildRequestState, buildSuccessState, buildFailureState } from './helpers'

export const initialState = {
  data: {},
  meta: {
    requestDone: false,
    errorDetail: ''
  }
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_AVAILABILITY_REQUEST:
      return buildRequestState(state)
    case FETCH_AVAILABILITY_SUCCESS:
      return buildSuccessState(state, payload)
    case FETCH_AVAILABILITY_FAILURE:
      return buildFailureState(state, payload)
    default:
      return state
  }
}

export { reducer }
